import { render } from "./StatisticalComponent.vue?vue&type=template&id=59617b32&ts=true"
import script from "./StatisticalComponent.vue?vue&type=script&lang=ts"
export * from "./StatisticalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__